import { useEffect, useState } from 'react';
import './Button.css';
import contract from './contracts/Chicken.json';
import eggcontract from './contracts/GoldenEgg.json';
import { ethers } from 'ethers';

const ChickenContractAddress = '0x605Ac47677A0Ef811E76E304dE7050A403f73B58';
const EggDistributorAddress = '0x190E366F6B09ceC36FEDe5c6385B328Ba8bE0cDE';
const GoldenEggAddress = '0x134597599A7aB4faD1A2DD72ABA872a6abf62b03';
const abi = contract.abi;
const eggabi = eggcontract.abi;

function ButtonTst() {
  const [currentAccount, setCurrentAccount] = useState(null);
  const [mintTokenId, setMintTokenId] = useState('0'); // '' is the initial state value
  const [queryTokenId, setQueryTokenId] = useState('0'); // '' is the initial state value
  const [claimTokenId, setClaimTokenId] = useState('0'); // '' is the initial state value
  const [eggtokenAmount, setEggTokenAmount] = useState('0'); // '' is the initial state value
  const [queryEGGTokenId, setQueryEGGTokenId] = useState('0'); // '' is the initial state value
  const [claimEGG, setClaimEGG] = useState('0'); // '' is the initial state value

  const checkWalletIsConnected = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log("Make sure you have Metamask installed!");
      return;
    } else {
      console.log("Wallet exists! We're ready to go!")
    }

    const accounts = await ethereum.request({ method: 'eth_accounts' });

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log("Found an authorized account: ", account);
      setCurrentAccount(account);
    } else {
      console.log("No authorized account found");
    }
  }

  const connectWalletHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      console.log("Found an account! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (err) {
      console.log(err)
    }
  }

  const mintNftHandler = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(ChickenContractAddress, abi, signer);

        console.log("Initialize payment");
        let nftTxn = await nftContract.publicMint(mintTokenId, { value: ethers.utils.parseEther("0.001") });

        console.log("Mining... please wait");
        await nftTxn.wait();

        console.log(`Mined, see transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`);

      } else {
        console.log("Ethereum object does not exist");
      }

    } catch (err) {
      console.log(err);
    }
  }

  const connectWalletButton = () => {
    return (
      <button onClick={connectWalletHandler} className='pixel-button connect-wallet-button'>
        Connect Wallet
      </button>
    )
  }

  const queryTokenHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const nftContract = new ethers.Contract(ChickenContractAddress, abi, signer);
      const nftTxn = await nftContract.checkBonus(queryTokenId, {});
      console.log("Quering... please wait");
      //await nftTxn.wait();
      alert("Token have " + nftTxn / 1000000000000000000 + " eth bonus")

    } catch (err) {
      console.log(err)
    }
  }


  const claimTokenHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const nftContract = new ethers.Contract(ChickenContractAddress, abi, signer);

      const nftTxn = await nftContract.claimBonus(claimTokenId);
      console.log("Claiming... please wait");
      await nftTxn.wait();
      alert("token claimed")
 
    } catch (err) {
      console.log(err)
      alert(err.data.message)
    }
  }

  const getEggTokenAmountHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const eggContract = new ethers.Contract(GoldenEggAddress, abi, signer);

      const amount = await eggContract.balanceOf(currentAccount);
      console.log("fetching..." + amount + currentAccount);
      setEggTokenAmount(amount / 1000000000000000000);

    } catch (err) {
      console.log(err)
      alert(err.data.message)
    }
  }


  const getClaimableEggTokenAmountHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const distributorContract = new ethers.Contract(EggDistributorAddress, abi, signer);

      const amount = await distributorContract.checkBonus(queryEGGTokenId);
      console.log("fetching..." + amount);
      alert("Token have " + amount / 1000000000000000000 + " egg bonus")
    } catch (err) {
      console.log(err)
      alert(err.data.message)
    }
  }

  const ClaimEggTokenHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const distributorContract = new ethers.Contract(EggDistributorAddress, abi, signer);

      const nftTxn = await distributorContract.claimBonus(claimTokenId);
      console.log("Claiming... please wait");
      await nftTxn.wait();
      alert("egg token claimed")

    } catch (err) {
      console.log(err)
      alert(err.data.message)
    }
  }


  const mintNftButton = () => {
    return (
      <button onClick={mintNftHandler} className='pixel-button mint-nft-button'>
        Mint NFT
      </button>
    )
  }

  useEffect(() => {
    checkWalletIsConnected();
  }, [])

  const showAllComponent = () => {
    return (
      <div>
        <label>
          parent token id to mint:
          <input value={mintTokenId} onInput={e => setMintTokenId(e.target.value)} />
        </label>
        <p />
        <button onClick={mintNftHandler} className='pixel-button mint-nft-button'>
          Mint NFT
        </button>
        <p />
        <label>
          token id to query:
          <input value={queryTokenId} onInput={e => setQueryTokenId(e.target.value)} />
        </label>
        <p />
        <button onClick={queryTokenHandler} className='pixel-button connect-wallet-button pixel-button'>query token bonus</button>

        <p >Claim your bonus</p>
        <label>
          token id to claim bonus:
          <input value={claimTokenId} onInput={e => setClaimTokenId(e.target.value)} />
        </label>
        <p />
        <button onClick={claimTokenHandler} className='pixel-button connect-wallet-button'>claim token bonus</button>
        <p />
        <p />
        <button onClick={getEggTokenAmountHandler} className='pixel-button connect-wallet-button'>Egg Token Amount {eggtokenAmount}</button>
        <p />
        <label>
          token id to query egg:
          <input value={queryEGGTokenId} onInput={e => setQueryEGGTokenId(e.target.value)} />
        </label>
        <p />
        <button onClick={getClaimableEggTokenAmountHandler} className='pixel-button connect-wallet-button pixel-button'>query Egg bonus</button>
        <p >Claim your Egg bonus</p>
        <label>
          token id to claim Egg bonus:
          <input value={claimEGG} onInput={e => setClaimEGG(e.target.value)} />
        </label>
        <p />
        <button onClick={ClaimEggTokenHandler} className='pixel-button connect-wallet-button'>claim egg bonus</button>
        <p />
        <p />
      </div>
    )
  }

  return (
    <div className='main-app'>
      <h1>Chicken mint test</h1>
      <div>
        {currentAccount ? showAllComponent() : connectWalletButton()}
      </div>
    </div>
  )
}

export default ButtonTst;
